import { useFetchWorkflowPreviousStep } from '@/hooks/use-workflow-previous-step';
import {
    WorkflowWorkflowType,
    WorkflowStepDefinition,
} from '@calm/evexia-web-sdk';
import { logger } from '@rhg/libs/logger';
import { useMutation } from '@rhg/libs/react-query';
import { FtueStoredStepName } from '@rhg/utils/workflows';
import { storeCurrentStep } from '../../utils';

export interface SkipCachedVideoStepParams {
    stepDefnId: string;
    workflowDefnId: string;
    onStepUpdate: (step: WorkflowStepDefinition | undefined) => void;
}

// Mutation hook for skipping cached video step backward
export function useSkipCachedVideoStepBackward() {
    const { fetchWorkflowPreviousStepAsync } = useFetchWorkflowPreviousStep();

    const { mutate, mutateAsync, ...otherProps } = useMutation({
        mutationFn: async (params: SkipCachedVideoStepParams) => {
            const { workflowDefnId, stepDefnId, onStepUpdate } = params;

            try {
                const response = await fetchWorkflowPreviousStepAsync({
                    workflowType: WorkflowWorkflowType.WorkflowUserRegistration,
                    workflowDefnId,
                });
                const stepObj = response?.stepDefn;
                const previousStep = stepObj?.defnId;
                onStepUpdate(stepObj);
                if (previousStep)
                    storeCurrentStep(FtueStoredStepName, previousStep);
                return response;
            } catch (error) {
                logger.error(
                    'Error updating cached workflow step backward:',
                    {
                        stepDefnId,
                        workflowDefnId,
                    },
                    error
                );
                throw error;
            }
        },
    });

    return {
        skipCachedVideoStepBackward: mutate,
        skipCachedVideoStepBackwardAsync: mutateAsync,
        ...otherProps,
    };
}
